import request from '@/utils/request'

/**
 * 查询加密狗应用即将到期数据分页（最近30天）
 * @param {*} params
 * @returns
 */
export const findDongleRecentExpirePage = (params) => {
  return request({
    url: '/sys/v1/dongleUser/findDongleRecentExpirePage',
    params
  })
}

/**
 * 停用加密狗用户授权功能(不续费，不在使用)
 * @param {*} data
 * @returns
 */
export const stopDongleUserModule = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/dongleUser/stopDongleUserModule',
    data
  })
}

/**
 * 查询授权应用应用即将到期数据分页（最近30天）
 * @param {*} params
 * @returns
 */
export const findAppRecentExpirePage = (params) => {
  return request({
    url: '/sys/v1/appTenant/findAppRecentExpirePage',
    params
  })
}

/**
 * 停止某个授权应用(不续费，不在使用)
 * @param {*} data
 * @returns
 */
export const stopAppModule = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/appTenant/stopAppTenant',
    data
  })
}
